angular.module('impactx.approval').controller('ApprovalListCtrl', ['selectedListItems', '$redirect', '$mdDialog', 'AppConfiguration', ApprovalListCtrl]);

function ApprovalListCtrl(selectedListItems, $redirect, $mdDialog, AppConfiguration) {

    var ctrl = this;

    ctrl.TYPE_PRH = "1";
    ctrl.TYPE_DEH = "2";
    ctrl.TYPE_BLH = "3";
    ctrl.TYPE_BUDGET = "7";

    ctrl.canExpand = function (row) {
        switch(row.type) {
            case ctrl.TYPE_PRH:
            case ctrl.TYPE_DEH:
            case ctrl.TYPE_BUDGET:
                return true;
            default:
                return false;
        }
    }

    ctrl.redirectToDetail = function() {
        var selected = selectedListItems.getSelectedItems()[0];
        switch(selected.type) {
            case  ctrl.TYPE_PRH:
                if (selected.substep.value === 2) {
                    $redirect.redirectTo(null, "/contractchangedialog/" + selected.id);
                }
                else if (selected.substep.value === 7) {
                    $redirect.redirectTo(null, "/cateringapproval/" + selected.id);
                }
                else {
                    $redirect.redirectTo(null, "/approvaldetailrequest/" + selected.id);
                }
                break;
            case ctrl.TYPE_DEH:
                $redirect.redirectTo(null, "/approvaldetaildemand/"+selected.id);
                break;
            case ctrl.TYPE_BLH:
                var route = "/approvaldetailinvoice/"+selected.id;
                if (AppConfiguration.get('useCustomInvoiceApproval')) {
                    route = '/custominvoiceapproval/'+selected.headerId+"/"+selected.id;
                }
                $redirect.redirectTo(null, route);
                break;
            case ctrl.TYPE_BUDGET:
                $redirect.redirectTo(null, "/approvaldetailbudget/"+selected.id);
                break;
            default:
                //should not happen normally.
                $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .textContent("Wrong doc type detected.")
                        .ariaLabel('Alert Dialog')
                        .ok('Ok')
                );
        }
    }

}